import * as $ from 'jquery';
import { $id } from '../../services/jquery-utils';
import { getWidgetForm } from './models/form';
import { toggleStopover } from './stopover';
import { isDesktop, returnMode } from './storage';

let $returnForm: JQuery, $button: JQuery;
let visible = false;

function setVisible(value: boolean): void {
    visible = value;

    if (visible) $returnForm.slideDown({ easing: 'linear' });
    else $returnForm.slideUp({ easing: 'linear' });

    toggleStopover(true, visible);
    $('#beginTekst').toggleClass('retour', visible);
    $id('mainForm').toggleClass('return', visible);
    setTimeout(() => $button.toggleClass('active', visible), visible ? 0 : 100);

    returnMode.value = visible;
}

function copyNoFlight() {
    // Copy noflight value to return
    const form = getWidgetForm();
    const route1Checked = form.noFlightCheck.prop('checked');
    const route2Checked = form.noFlightCheck.prop('checked');

    if (route1Checked !== route2Checked) {
        form.noFlightCheck.prop('checked', route1Checked).change();
    }
}

export function loadReturn(): void {
    $returnForm = $id('retourform-wrapper');
    $button = $id('return-btn');

    // Desktop:
    let firstTime = true;
    $button.click(function btnClick(e) {
        e.preventDefault();

        // Set return noflight
        if (firstTime) {
            firstTime = false;

            copyNoFlight();
            getWidgetForm().noFlightCheck.click(() => copyNoFlight());
        }

        setVisible(!visible);
    });

    // Mobile:
    $id('returnButton').on('click', function (event) {
        if (isDesktop) return;

        event.preventDefault();

        // Bugfix: Do not accept triggers
        if (typeof event.originalEvent === 'undefined') return;

        const wilReturn = $(this).prop('id') === 'returnButton';

        const $form = $id('formDiv'),
            $formReturn = $id('formDivReturn');

        (wilReturn ? $form : $formReturn).slideUp();
        (wilReturn ? $formReturn : $form).slideDown();

        const $returnBtn = $id('returnButton');
        if (wilReturn) {
            $returnBtn.fadeOut();
        } else {
            $returnBtn.fadeIn();
        }

        returnMode.value = wilReturn;
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/return.ts